import { SupportRequestResultsModalTableRow } from '../../../../types';
import { NotMyPropertyFormValues } from './steps/not-my-property';
import { UpdatePropertyAddressFormValues } from './steps/update-property-address';
import { UpdatePropertyNameFormValues } from './steps/update-property-name';
import { ReasonForNearFormValues } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/steps/reason-for-nearby';

export const enum EAskFowReviewFormSectionType {
    ReasonForSensitive = 1,
    ReasonForNearby = 2,
    NotMyProperty = 3,
    UpdatePropertyName = 4,
    UpdatePropertyAddress = 5,
}

export type AskForReviewFormSectionValue = NotMyPropertyFormValues &
    UpdatePropertyAddressFormValues &
    UpdatePropertyNameFormValues &
    ReasonForNearFormValues;

export type AskForReviewOnSubmitProps = {
    type: EAskFowReviewFormSectionType;
    data: AskForReviewFormSectionValue;
    item: SupportRequestResultsModalTableRow;
};

export type AskForReviewProps = {
    onSubmit: (props: AskForReviewOnSubmitProps) => void;
    item: SupportRequestResultsModalTableRow;
};
